import { useAppDispatch } from "@/app/store/hooks";
import { FeedbackForm } from "@/features/feedbacks/ui/FeedbackForm";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { complatedModalOpen } from "@/widgets/modal/model/slice";

export function PrivateBrokerConsultation() {

    const dispatch = useAppDispatch();
    
    const handleSubmit = (name: string, phone: string) => {
        
        // send data logic
        console.log(name, phone);
        
        dispatch(complatedModalOpen());
    }

    return (
        <SectionLayout
            className=""
            containerClassName="relative flex flex-col py-[40px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[32px] bg-blue px-[16px] py-[20px] md:p-[40px] rounded-[10px]">
                <div className="flex flex-col gap-[20px] md:gap-[32px]">
                    <Typography tag="h2" className="text-white">
                        Частная консультация с брокером
                    </Typography>
                    <div className="max-w-[600px] flex flex-col gap-[20px]">
                        <Typography className="uppercase text-white font-semibold md:text-[18px] !leading-[120%]">
                            Оставьте свои контакты, и мы подберём для вас эксклюзивные варианты недвижимости
                        </Typography>
                        <Typography className="uppercase text-white font-normal text-[14px] md:text-[16px] !leading-[120%]">
                            Наши эксперты свяжутся с вами в ближайшее время
                        </Typography>
                    </div>
                </div>

                <FeedbackForm 
                    bgBlue={true}
                    onSubmit={handleSubmit}
                />
            </div>
        </SectionLayout>
    );
}
